import { formatList } from "../gating";
import { BASE_DATA_LAYERS, formatCount } from "../layers";

import { BOUNDARY_IMPORT_KEYS, BoundaryImportKey } from "./boundary";

/** Return the lowercase nouns of base data layers as a list, e.g. "addresses, parcels and streets". */
export const formatImportNouns = (keys: readonly BoundaryImportKey[]): string => formatList(keys.map((key) => BASE_DATA_LAYERS[key].noun));

/** Imported feature counts of each base data layer, one per planner layer. */
export type ImportCounts = Partial<Record<BoundaryImportKey, number[]>>;

/**
 * Return the result line of an import: the counts of one base data layer, e.g. "12 spans · 30 poles imported", or the names of several,
 * e.g. "Addresses and parcels imported".
 */
export const formatImportResult = (counts: ImportCounts): string => {
  const keys = BOUNDARY_IMPORT_KEYS.filter((key) => counts[key]);
  if (keys.length > 1) {
    const nouns = formatImportNouns(keys);
    return `${nouns.charAt(0).toUpperCase()}${nouns.slice(1)} imported`;
  }
  const parts = keys.flatMap((key) => {
    const { layers } = BASE_DATA_LAYERS[key];
    return (counts[key] ?? []).map((count, index) => formatCount(count, layers[index].units));
  });
  return `${parts.join(" · ")} imported`;
};
